
import * as api_config from '../config/api_config'

export default {
  addNotification(axios, payload) {
    return axios.post(`${api_config.ADDRESS}/notifications`, {notification: payload}, {headers: api_config.HEADERS});
  }
};
